import { render } from "./DragCard.vue?vue&type=template&id=70d4cae4&scoped=true&ts=true"
import script from "./DragCard.vue?vue&type=script&lang=ts"
export * from "./DragCard.vue?vue&type=script&lang=ts"

import "./DragCard.vue?vue&type=style&index=0&id=70d4cae4&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d4cae4"]])

export default __exports__